





















































































































import { UnifiedInsightsReportsStoreState } from './unified-insights-reports.store';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwContentToolbar } from '@libs-uuif/shared/sw-content-toolbar';
import {
  SwTextfield,
  SwExpandableTextfield,
} from '@libs-uuif/shared/sw-textfield';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import ReportActions from './report-actions.vue';
import { Watch, Component } from 'vue-property-decorator';
import {
  TableColumnConfig,
  SwTable,
  TableEntry,
  TableEntrySelectingEventData,
  ColumnSortRequestData,
  SortedColumnInfo,
  ColumnsAdjustRequestData,
} from '@libs-uuif/shared/sw-table';
import { DataSet } from './report-constants';
import { CreateElement, VNode } from 'vue';
import { SwPanelGroup, SwPanel } from '@libs-uuif/shared/sw-panel';
import { State, namespace, Mutation } from 'vuex-class';
import CreateEditReport from './components/sw-create-edit-report.vue';
import { messageService } from '@libs-uuif/shared/message-service';
import { unifiedMessageContainer } from '@/shared/constants';
import ReportFilter from './report-filter.vue';
import FilterBrief from './filter-brief.vue';
import { unifiedInsightsApiService } from '@/shared/api-service/unified-insights-api-wrapper';
import moment from 'moment';
import { nsmReportingApi } from './shared/nsm-reporting-api';
import { CoreStoreState } from '@/core';
import { RootStoreState } from '@/store';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { ccReportingApi } from './shared/cc-reporting-api';
import fileDownload from 'js-file-download';
import _ from 'lodash';
import { wcmApiService } from '@/shared/api-service/wcm-api-service';
import { sessionStorageKeeperService, localStorageKeeperService } from '@/shared/auth-service';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { nsmApiService } from '@/shared/api-service/nsm-api-service';

const cssPrefix = 'unified-insights-reports';
const reportStoreModule = namespace('UnifiedInsightsReportsStoreModule');

@Component({
  components: {
    SwTable,
    SwPanelGroup,
    SwPanel,
    SwIconButton,
    SwIcon,
    SwContentToolbar,
    SwTextfield,
    SwExpandableTextfield,
    CreateEditReport,
    ReportFilter,
    SwBlockingProgress,
    FilterBrief,
  },
})
export default class UnifiedInsightsReports extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @reportStoreModule.State
  filterData: UnifiedInsightsReportsStoreState['filterData'];

  @reportStoreModule.Mutation
  setNsmMetaData: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['nsmMetaData']>;

  @reportStoreModule.Mutation
  setWcmOnDemandReportsCount: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['totalWcmOnDemandReports']>;

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  tenantName: CoreStoreState['tenantName'];

  @State((state: RootStoreState) => state.CoreStoreModule.nsmBaseUrl)
  nsmBaseUrl: CoreStoreState['nsmBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.productList)
  productList: CoreStoreState['productList'];

  @State((state: RootStoreState) => state.CoreStoreModule.ccBaseUrl)
  ccBaseUrl: CoreStoreState['ccBaseUrl'];

  @Mutation
  setTenantGroups: VuexMappedMutation<CoreStoreState['tenantGroups']>;

  stringToSearch = '';
  refreshRate: number = 60;
  isRowSelectable: boolean = true;
  interval: any;
  loadedData: TableEntry[] = [];
  expandVisible: boolean = false;
  reportTypeFilterValue: string[] = [];
  statusFilterValue: string[] = [];
  productFilterValue: string[] = [];
  deliveryMethodFilterValue: string[] = [];
  filterCheckVal: string[] = [];
  display: boolean = false;
  color: string = '';
  openSearch: boolean = false;
  reportEditData: any[] = [];
  isReportEdit: boolean = false;
  disableSaveButton: boolean = false;
  filteredData: DataSet[] = [];
  dummyData: DataSet[] = [];
  dataSet: DataSet[] = [];
  ccScheduleFlag: boolean = true;
  nsmRuleFlag: boolean = true;
  ccAvailableFlag: boolean = true;
  nsmArchiveFlag: boolean = true;
  wnmFlag: boolean = true;
  selectedRowsKeys: number[] = [];
  sortedColumns: SortedColumnInfo[] = [
    {
      colKey: 'request at',
      ascending: false,
    },
  ];
  isLoading: boolean = false;
  watchTenantName: boolean = false;
  nsmReportInprogress : any[] = [];
  clearTimeoutVar : any;
  isReadOnly: boolean = false;
  /**
   * @desc Calls all the report APIs again.
   */
  refreshReport() {
    if (this.productList.includes('NGMGMT')) {
      this.setNsmGroups();
    }
    this.getDebouncedMethod();
  }

  /**
   * @desc Closes report modal.
   */
  closeModal() {
    this.display = false;
    this.isReportEdit = false;
  }

  get getDebouncedMethod() {
    return _.debounce(
      () => {
        this.getReportDataFromApi();
      },
      400,
    );
  }

  /**
   * @desc Opens create report modal.
   */
  async openAddModal() {
    this.display = true;
    if (this.productList.includes('NGMGMT')) {
      this.isLoading = true;
      await this.getMetaData();
    }
  }

  beforeMount() {
    this.checkIfReadOnlyUser();
  }

  checkIfReadOnlyUser() {
    const currentUser = JSON.parse(
      localStorageKeeperService.retrieve('currentUser'),
    );
    if (currentUser &&
      currentUser.roles) {
      if (Array.isArray(currentUser.roles)) {
        this.isReadOnly = currentUser.roles.length > 0 &&
          currentUser.roles.includes('SPOGREADONLY') || false;
      } else if (typeof currentUser.roles === 'string') {
        this.isReadOnly = currentUser.roles &&
          currentUser.roles.indexOf('SPOGREADONLY') > -1 || false;
      } else {
        this.isReadOnly = false;
      }
    }
  }
  /**
   * @desc Opens edit report modal.
   * @param data Information about existing report.
   */
  async openEditModal(data: any[]) {
    this.isReportEdit = true;
    this.reportEditData = data;
    this.display = true;
    if (this.productList.includes('NGMGMT')) {
      this.isLoading = true;
      await this.getMetaData();
    }
  }

  /**
   * @desc Loads more data when user tries to scroll.
   * @param minNumToLoad number of entries according to page size.
   */
  private onLoadMore(minNumToLoad: number) {
    this.populateData(this.loadedData.length, Math.max(minNumToLoad, 20));
  }

  /**
   * @desc Push data to table.
   * @param start first displayed entry in table for current page.
   * @param length page length
   */
  private populateData(start: number, length: number) {
    if (length <= 0) {
      return;
    }
    if (this.loadedData.length < this.tableData.length) {
      let count = 0;
      for (
        ;
        count < length && start + count < this.tableData.length;
        count += 1
      ) {
        this.loadedData.push(this.tableData[start + count]);
      }
    }
  }

  /*
    @desc By clicking on filter icon filter drop down menu will be shown.
  */
  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  /*
    @desc Returns length of filters based on the length filter brief component will be rendered.
  */
  get briefFilterApplied(): boolean {
    const { reportType, deliveryMethod, status, product } = this.filterData;
    return (
      reportType.length ||
      deliveryMethod.length ||
      status.length ||
      product.length
    );
  }

  adjustedColumnsWidth: ColumnsAdjustRequestData = {};

  /**
   * @desc Adjusts column width.
   * @param data Width of columns.
   */
  private onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumnsWidth = data;
  }

  get resultColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'selection',
        type: 'selection',
        headerCellClassName: 'sw-qsg-el-report-task',
      },
      // {
      //   key: 'id',
      //   dataKey: 'id',
      //   title: 'Report ID',
      //   sorter: true,
      //   width: 100,
      //   // tslint:disable-next-line
      //   render: (h, data: any): VNode => {
      //     return (
      //       <span
      //         class={[`${this.cssPrefix}__overflow-restrict`]}
      //         v-tooltip={{
      //           content: data.entry.id,
      //           placement: 'right',
      //           compact: true,
      //         }}
      //       >
      //         <span class={[`${this.cssPrefix}__overflow-restrict`]}>
      //           {data.entry.id}
      //         </span>
      //       </span>
      //     ) as VNode;
      //   },
      // },
      {
        key: 'report name',
        dataKey: 'report_name',
        title: this.$t('spog.unifiedInsights.reportName')
        .toString()
        .toUpperCase(),
        sorter: (a: TableEntry, b: TableEntry) => {
          return  (a.report_name || '')
          .localeCompare(b.report_name || '', undefined, {
            numeric: true,
          });
        },
        // tslint:disable-next-line
        render: (h, data: any): VNode => {
          return (
            <span
              class={[`${this.cssPrefix}__overflow-restrict`]}
              v-tooltip={{
                content: data.entry.report_name,
                placement: 'right',
                compact: true,
              }}
            >
              <span class={[`${this.cssPrefix}__overflow-restrict`]}>
                {data.entry.report_name}
              </span>
            </span>
          ) as VNode;
        },
      },
      {
        key: 'product name',
        dataKey: 'product_name',
        title: this.$t('catalog.productName')
        .toString()
        .toUpperCase(),
        sorter: (a: TableEntry, b: TableEntry) => {
          return  (a.product_name || '')
          .localeCompare(b.product_name || '', undefined, {
            numeric: true,
          });
        },
        width: 100,
      },
      {
        key: 'report type',
        dataKey: 'report_type',
        title: this.$t('spog.unifiedInsights.reportType')
        .toString()
        .toUpperCase(),
        sorter: (a: TableEntry, b: TableEntry) => {
          return  (a.report_type || '')
          .localeCompare(b.report_type || '', undefined, {
            numeric: true,
          });
        },
      },
      {
        key: 'delivery method',
        dataKey: 'delivery_method',
        title: this.$t('spog.unifiedInsights.deliveryMethod')
        .toString()
        .toUpperCase(),
        sorter: (a: TableEntry, b: TableEntry) => {
          return  (a.delivery_method || '')
          .localeCompare(b.delivery_method || '', undefined, {
            numeric: true,
          });
        },
        width: 140,
      },
      // {
      //   key: 'request at',
      //   dataKey: 'request_at',
      //   title: 'REQUESTED AT',
      //   sorter: true,
      //   width: 180,
      // },
      {
        key: 'last run time',
        dataKey: 'last_run_time',
        title: this.$t('spog.unifiedInsights.lastRunTime')
        .toString()
        .toUpperCase(),
        sorter: true,
        width: 180,
      },
      // {
      //   key: 'report generated at',
      //   dataKey: 'report_generated_at',
      //   title: 'REPORT GENERATED AT',
      //   sorter: true,
      //   width: 180,
      // },
      {
        key: 'status',
        dataKey: 'status',
        title: this.$t('products.status')
        .toString()
        .toUpperCase(),
        sorter: (a: TableEntry, b: TableEntry) => {
          return  (a.status || '')
          .localeCompare(b.status || '', undefined, {
            numeric: true,
          });
        },
        width: 100,
      },
      {
        key: 'actions',
        dataKey: 'actions',
        // title: 'ACTIONS',
        title: (h: CreateElement): VNode => {// tslint:disable-line
          return (
            <div>
              <span class={['sw-qsg-el-reports-action']} style={{ padding: '5px 10px' }}>{ this.$t('products.actions')
              .toString()
              .toUpperCase() }</span>
            </div> as VNode
          );
        },
        width: 78,
        // tslint:disable-next-line
        render: (h: CreateElement, data): VNode => {
          return (
            <ReportActions
              enableEditDelete={this.isReadOnly ? false : true}
              onActionPerformed={(val: boolean) => this.updateReportData(val)}
              reportData={data.entry}
              onEditSa={() => {
                data.entry.product_name === 'Wireless' ?
                this.openEditModal([data.entry]) :
                this.openEditModal(data.entry.reportData);
              }}
              entry={data.entry}
            />
          ) as VNode;
        },
      },
    ];
  }

  /**
   * @desc Sorts data based on the input.
   * @param data Sorting operation performed on table data.
   */

  onRequestSorting(data: ColumnSortRequestData) {
    /** for now, we only support single-column sorting */
    const index = this.sortedColumns.findIndex(
      col => col.colKey === data.colKey,
    );
    if (index < 0) {
      if (data.cancel) {
        return;
      }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  /**
   * @desc Updates report data on any action.
   */
  updateReportData(val: boolean) {
    if (val) {
      this.getReportDataFromApi();
    }
  }

  /**
   * @desc Selects and Deselects entry.
   * @param data Table data.
   */
  onEntrySelecting(data: TableEntrySelectingEventData) {
    const selectedKey: any = data.entryKey;
    if (data.selecting) {
      this.selectedRowsKeys.push(selectedKey);
    } else {
      if (this.selectedRowsKeys.length > 0) {
        const selectedEntryIndex = this.selectedRowsKeys.indexOf(selectedKey);
        this.selectedRowsKeys.splice(selectedEntryIndex, 1);
      }
    }
  }
  /**
   * @desc Downloads WNM archive report.
   * @param selectedIds obj of report which are selected by user.
   */
  downloadWNMArchivedReport(selectedIds : any) {
    console.warn(selectedIds);
    selectedIds.forEach((ele : any) => {
      const reportName = ele.filename ? ele.filename : `${ele.id}.pdf`;
      const url = ele.url;
      wcmApiService.downloadWirelessReport(reportName, url, false);
    });
  }
  /**
   * @desc Downloads CC archive report.
   * @param selectedIds obj of report which are selected by user.
   */
  async downloadCCArchivedReport(selectedIds : any) {
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.dwnldSelRep')
      .toString(),
      'informational',
    );
    const tempApiCall : any[] = [];
    selectedIds.forEach((ele : any) => {
      if (ele?.report_type === 'OnDemand') {
        tempApiCall.push(ccReportingApi
      .download(this.ccBaseUrl, ele.taskId));
      } else if (ele.report_type.indexOf('Scheduled') > -1) {
        console.warn(ele);
        const apiParams = {
          frequency: ele?.reportData[0]?.schedule,
          nbItems:
            ele?.reportData[0]?.schedule === 'hourly'
          ? 24
          : ele?.reportData[0]?.schedule === 'daily'
          ? 30
          : ele?.reportData[0]?.schedule === 'weekly'
          ? 26
          : ele?.reportData[0]?.schedule === 'monthly'
          ? 12
          : 30,
          threats: ele?.reportData[0]?.threatsSection,
          applications: ele?.reportData[0]?.applicationsSection,
          activities: ele?.reportData[0]?.activitiesSection,
          webProtection: ele?.reportData[0]?.webProtectionSection,
          atp: ele?.reportData[0]?.atpSection,
          devices: ele?.reportData[0]?.devicesSection,
          tenants: ele?.reportData[0]?.tenantsSection,
          threatHistory: ele?.reportData[0]?.includeThreatHistory,
          atpHistory: ele?.reportData[0]?.includeAtpHistory,
          deviceHistory: ele?.reportData[0]?.includeDeviceHistory,
          threatList: ele?.reportData[0]?.includeThreatList,
          atpList: ele?.reportData[0]?.includeAtpList,
          deviceList: ele?.reportData[0]?.includeDeviceList,
          tenantList: ele?.reportData[0]?.includeTenantList,
          fileFormat: ele?.reportData[0]?.fileFormat,
        };
        tempApiCall.push(ccReportingApi
      .generalReportAsPdf(this.ccBaseUrl, apiParams));
      }
    });
    Promise.allSettled([
      ...tempApiCall,
    ])
    .then((resp : any) => {
      resp.forEach((downloadItem : any, index : any) => {
        if (downloadItem.data) {
          fileDownload(
            downloadItem.data,
            `${selectedIds[index].report_name}.${selectedIds[index].fileFormat}`,
          );
        }
      });
      messageService.messageManager.showMessage(
        unifiedMessageContainer,
        this.$t('spog.unifiedInsights.selRepDwnld')
        .toString(),
        'success',
      );
      this.refreshReport();
    });
  }

  /**
   * @desc Delete bulk CC  reports.
   * @param selectedIds Ids of report which are selected by user.
  */
  async deleteBulkCCReports(selectedIds: any) {
    this.isLoading = true;
    let scheduleId:string = '';
    selectedIds && selectedIds.forEach((element: any, index: number) => {
      if (element?.reportType?.toUpperCase() !== 'ONDEMAND') {
        if (index === 0) {
          scheduleId = `${element.scheduleId}`;
        } else {
          scheduleId = `${scheduleId},${element.scheduleId}`;
        }
      }
    });
    ccReportingApi.deleteSchedule(this.ccBaseUrl, scheduleId)
    .then((resp : any) => {
      this.isLoading = false;
      console.warn(resp);
      messageService.messageManager.showMessage(
        unifiedMessageContainer,
        selectedIds.length > 1 ? this.$t('spog.unifiedInsights.selRepDel')
        .toString() : this.$t('spog.unifiedInsights.selRepDel')
        .toString() ,
        'success',
      );
      this.refreshReport();
    })
    .catch((errorResponse: any) => {
      this.isLoading = false;
      console.error(errorResponse);
      messageService.messageManager.showMessage(
        unifiedMessageContainer,
        selectedIds.length > 1 ? this.$t('spog.unifiedInsights.selRepDelFail')
        .toString() : this.$t('spog.unifiedInsights.selRepDelFail')
        .toString(),
        'failed',
      );
    });
  }

  /**
   * @desc Downloads NSM archive report.
   * @param selectedIds Ids of report which are selected by user.
   */
  async downloadNsmArchivedReport(selectedIds: string[], view : any) {
    const id = selectedIds.join(',');
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.dwnldSelRep')
      .toString(),
      'informational',
    );
    this.isLoading = true;
    await nsmReportingApi
      .downloadNsmArchivedReport(this.nsmBaseUrl, id, view)
      .then((response) => {
        if (response.data.fileData) {
          const binaryString = atob(response.data.fileData.replace(/\s/g, ''));
          const stringLength = binaryString.length;
          const buffer = new ArrayBuffer(stringLength);
          const data = new Uint8Array(buffer);
          for (let i = 0; i < stringLength; i = i + 1) {
            data[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([data], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.$t('spog.unifiedInsights.selRepDwnld')
            .toString(),
            'success',
          );
          this.refreshReport();
        } else {
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.$t('spog.unifiedInsights.dwnldSelRepFail')
            .toString(),
            'failed',
          );
        }
      })
      .catch((error) => {
        console.error('Report Download API error ', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.dwnldSelRepFail')
          .toString(),
          'failed',
        );
      })
      .finally(() => {
        this.isLoading = false;
        this.onFilterApply();
      });
  }

  /**
   * @desc Delete confirmation for user after clicking on delete action.
   */
  private deleteConfirmation(extraMsg: string = '') {
    return confirmService.confirm({
      message: extraMsg ? `${extraMsg}.  ${this.$t('spog.unifiedInsights.delSelRepCnfrm')
      .toString()}` : `${this.$t('spog.unifiedInsights.delSelRepCnfrm')
      .toString()}`,
      title: this.$t('spog.unifiedInsights.timeFrameMsg')
      .toString(),
      status: 'informational',
      buttons: [
        {
          key: 'cancel',
          name: this.$t('common.cancel')
          .toString(),
        },
        {
          key: 'proceed',
          name: this.$t('spog.unifiedInsights.proceed')
          .toString(),
          isDefault: true,
        },
      ],
    });
  }

  /**
   * @desc Delete NSM Archive reports based on the input.
   * @param selectedIds Ids of report which are selected by user.
   */
  async deleteSelectedNsmArchivedReport(selectedIds: string[]) {
    const id = selectedIds.join(',');
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.selRepBeingDel')
      .toString(),
      'informational',
    );

    await nsmReportingApi
      .deleteNsmArchivedReport(this.nsmBaseUrl, id)
      .then(() => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.selReprDelSucc')
          .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
        this.refreshReport();
      })
      .catch((error: any) => {
        console.error('Report API Error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.selReprDelFail')
          .toString(),
          'failed',
        );
      });
  }

  /**
   * @desc Delete NSM rule reports based on the input.
   * @param selectedIds Ids of report which are selected by user.
   */
  async deleteSelectedNsmRuleReport(selectedIds: string[]) {
    const id = selectedIds.join(',');
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.selRepBeingDel')
      .toString(),
      'informational',
    );

    await nsmReportingApi
      .deleteNsmScheduleReport(this.nsmBaseUrl, id)
      .then(() => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.selReprDelSucc')
          .toString(),
          'success',
        );
        this.refreshReport();
      })
      .catch((error: any) => {
        console.error('Report API Error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.selReprDelFail')
          .toString(),
          'failed',
        );
      });
  }

  /**
   * @desc Download reports based on the input.
   */
  downloadSelectedEntries() {
    const selectedRowsReportIds: any = [];
    const selectedRowsReportIdsForCC: any = [];
    const selectedRowsReportIdsForWNM: any = [];
    let view : any;
    // tslint:disable-next-line
    this.selectedRowsKeys.map((entry, i) => {
      const downloadEntry: any = this.tableData.find((item: any) => {
        return item['_key'] === this.selectedRowsKeys[i];
      });
      if (downloadEntry.product_name === 'Capture Client') {
        selectedRowsReportIdsForCC.push(downloadEntry);
      } else if (downloadEntry.product_name === 'Wireless') {
        selectedRowsReportIdsForWNM.push(downloadEntry);
      } else {
        view = downloadEntry.view;
        selectedRowsReportIds.push(downloadEntry._id);
      }
    });
    if (selectedRowsReportIds.length > 0) {
      this.downloadNsmArchivedReport(selectedRowsReportIds, view);
    }
    if (selectedRowsReportIdsForCC.length > 0) {
      // added this code for cc report generation ticket .. will add this later
      this.downloadCCArchivedReport(selectedRowsReportIdsForCC);
    }
    if (selectedRowsReportIdsForWNM.length > 0) {
      this.downloadWNMArchivedReport(selectedRowsReportIdsForWNM);
    }
  }

  /**
   * @desc Delete reports based on the input.
   */
  deleteSelectedEntries() {
    const selectedRowsArchieveReportIds: any = [];
    const selectedRowsRuleReportIds: any = [];
    const selectedCCRowsArchieveReportIds: any = [];
    const selectedWNMRowsArchieveReportIds: any = [];
    for (const i in this.selectedRowsKeys) {
      const downloadEntry: any = this.tableData.find((item: any) => {
        return item['_key'] === this.selectedRowsKeys[i];
      });
      if (downloadEntry.product_name === 'Wireless') {
        selectedWNMRowsArchieveReportIds.push(downloadEntry.id);
      } else if (downloadEntry.product_name === 'Capture Client') {
        selectedCCRowsArchieveReportIds.push(downloadEntry);
      } else if (downloadEntry) {
        if (downloadEntry.reportType === 'Rules') {
          selectedRowsRuleReportIds.push(downloadEntry.scheduleId);
        } else {
          selectedRowsArchieveReportIds.push(downloadEntry.scheduleId);
        }
      }
    }
    if (selectedWNMRowsArchieveReportIds.length > 0) {
      this.deleteConfirmation()
      .then((confirmKey) => {
        if (confirmKey === 'proceed') {
          console.warn(selectedWNMRowsArchieveReportIds);
          const reportId = selectedWNMRowsArchieveReportIds;
          const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
          let tenantId = '';
          if (
            wcmSession &&
            wcmSession.ssoKeys &&
            wcmSession.ssoKeys.tenants &&
            wcmSession.ssoKeys.tenants.length > 0
          ) {
            tenantId = wcmSession.ssoKeys.tenants[0].tenant_id || '';
          }
          messageService.messageManager.showMessage(
              unifiedMessageContainer,
              this.$t('spog.unifiedInsights.selRepBeingDel')
              .toString(),
              'informational',
            );
          wcmApiService
            ?.deleteMultipleReportWithDelete(`/tenants/${tenantId}/system/reports/tasks/delete`, reportId)
            .then(() => {
              messageService.messageManager.showMessage(
                unifiedMessageContainer,
                this.$t('spog.unifiedInsights.selReprDelSucc')
                .toString(),
                'success',
            );
              this.getReportDataFromApi();
            })
            .catch((error: any) => {
              console.error('Report API Error', error);
              messageService.messageManager.showMessage(
                unifiedMessageContainer,
                this.$t('spog.unifiedInsights.selReprDelFail')
                .toString(),
                'failed',
              );
            });
        }
      });
    }
    if (selectedCCRowsArchieveReportIds.length > 0 || selectedCCRowsArchieveReportIds.length > 0) {
      const isAnyOnDemandReports = selectedCCRowsArchieveReportIds.some((report: any) => {
        return report?.reportType?.toUpperCase() === 'ONDEMAND';
      }) || false;
      this.deleteConfirmation(isAnyOnDemandReports ? this.$t('spog.unifiedInsights.delOnDmndRep')
          .toString() : '')
      .then((confirmKey) => {
        if (confirmKey === 'proceed') {
          this.deleteBulkCCReports(selectedCCRowsArchieveReportIds);
        }
      });
    }
    if (selectedRowsArchieveReportIds.length > 0 || selectedRowsRuleReportIds.length > 0) {
      this.deleteConfirmation()
      .then((confirmKey) => {
        if (confirmKey === 'proceed') {
          if (selectedRowsArchieveReportIds.length > 0 && selectedRowsRuleReportIds.length > 0) {
            messageService.messageManager.showMessage(
              unifiedMessageContainer,
              this.$t('spog.unifiedInsights.selRepBeingDel')
              .toString(),
              'informational',
            );
            Promise.all([
              nsmReportingApi
              .deleteNsmArchivedReport(this.nsmBaseUrl, selectedRowsArchieveReportIds.join(',')),
              nsmReportingApi
              .deleteNsmScheduleReport(this.nsmBaseUrl, selectedRowsRuleReportIds.join(',')),
            ])
            .then(() => {
              messageService.messageManager.showMessage(
                unifiedMessageContainer,
                this.$t('spog.unifiedInsights.selReprDelSucc')
                .toString(),
                'success',
              );
              this.refreshReport();
            })
            .catch((error: any) => {
              console.error('Report API Error', error);
              messageService.messageManager.showMessage(
                unifiedMessageContainer,
                this.$t('spog.unifiedInsights.selReprDelFail')
                .toString(),
                'failed',
              );
            });
          } else {
            selectedRowsArchieveReportIds.length > 0 && this.deleteSelectedNsmArchivedReport(selectedRowsArchieveReportIds);
            selectedRowsRuleReportIds.length > 0 && this.deleteSelectedNsmRuleReport(selectedRowsRuleReportIds);
          }
        }
      });
    }
  }

  get disableDownload() {
    const selectedRowsRuleReportIds: any = [];
    for (const i in this.selectedRowsKeys) {
      const downloadEntry: any = this.tableData.find((item: any) => {
        return item['_key'] === this.selectedRowsKeys[i];
      });
      if (downloadEntry && downloadEntry.reportType === 'Rules') {
        selectedRowsRuleReportIds.push(downloadEntry.scheduleId);
      }
    }
    return this.selectedRowsKeys.length === 0 || selectedRowsRuleReportIds.length > 0;
  }

  /**
   * @desc Returns data object with key.
  */
  get isCConDemandCheck() {
    const selectedEntries: any [] = [];
    if (this.selectedRowsKeys && this.selectedRowsKeys.length === 0) {
      return  false;
    }
    for (const i in this.selectedRowsKeys) {
      const downloadEntry: any = this.tableData.find((item: any) => {
        return item['_key'] === this.selectedRowsKeys[i];
      });
      downloadEntry && selectedEntries.push(downloadEntry);
    }
    if (selectedEntries && selectedEntries.length > 0 && selectedEntries.every((entry: any) => {
      return entry.product_name &&
        entry.reportType &&
        entry.product_name === 'Capture Client' &&
        entry.reportType === 'OnDemand';
    })) {
      return false;
    }
    return true;
  }

  /**
   * @desc Returns data object with key.
   */
  get tableData(): TableEntry[] {
    const labels = this.dummyData.map((entry: any, index: number) => {
      return {
        _key: `${entry.id}-${String(index)}-${entry.product_name}`,
        id: String(entry.id),
        product_name:
          String(entry.product_name)
            .charAt(0)
            .toUpperCase() + String(entry.product_name)
            .slice(1),
        status: String(entry.status),
        report_type: String(entry.report_type),
        delivery_method: String(entry.delivery_method),
        reportData: entry.reportData,
        report_name: String(entry.report_name),
        request_at: String(entry.requested_at),
        last_run_time : String(entry.last_run_time),
        report_generated_at: String(entry.generated_at),
        downloadUrl: String(entry.downloadUrl),
        taskId: String(entry.taskId),
        productName: String(entry.productName),
        fileFormat: String(entry.fileFormat),
        intervalType: entry.intervalType ? entry.intervalType : 0,
        view : entry.view ? String(entry.view) : '-',
        ccScheduleReportData:
          entry.reportType === 'Scheduled' &&
          entry.productName === 'Capture Client'
            ? entry.ccScheduleReportData
            : null,
        scheduleId:
          // entry.reportType === 'Rules' && entry.productName === 'firewall' ||
          entry.productName === 'firewall' ||
          entry.productName === 'Capture Client' && entry.reportType === 'Scheduled'
            ? entry.scheduleId
            : '',
        _id: entry.productName === 'firewall' ? entry._id : '',
        reportType: entry.reportType,
        archiveFiles: entry.productName === 'firewall' && entry.archiveFiles || [],
        config: entry.product_name === 'Wireless' ? entry.config : {},
        url: entry.productName === 'Wireless' ? entry.url : '',
        filename : entry.product_name === 'Wireless' && entry.filename ? entry.filename : '',
        // will add this line when we need to enable report download and delete for capture client
        _selectable:
          entry.product_name === 'Firewall' ||
          entry.product_name === 'Capture Client' ||
          entry.product_name === 'Wireless'
            ? true
            : false,
        wnmScheduleReportData: entry.product_name === 'Wireless' &&
          entry.option ? entry.option : {},
        // _selectable:
        //   entry.product_name === 'Firewall'
        //     ? true
        //     : false,
      };
    });
    return labels;
  }

  /**
   * @desc API call for report.
   */
  getReportDataFromApi() {
    this.dataSet = [];
    this.dummyData = [];
    this.loadedData = [];
    this.productList.map(async(product) => {
      try {
        if (product === 'NGMGMT') {
          await this.getNsmReportData();
          // await this.getNsmArchiveReportData();
        } else if (product === 'Capture Client') {
          await this.getCcReportData();
          await this.getCcScheduledReportData();
        } else if (product === 'Wireless') {
          await this.getWnmReportData();
        }
      } catch (e) {
        console.error(e);
      }
    });
  }

  /**
   * @desc Based on users input in filter fields data will be filtered.
   */
  @Watch('filterData', { deep: true })
  onFilterApply() {
    let tempData = [...this.dataSet];
    if (this.filterData.reportType.length > 0) {
      this.reportTypeFilterValue = [...this.filterData.reportType];
      this.reportTypeFilterValue.map((entry: any, index: number) => {
        this.reportTypeFilterValue[index] = entry.toLocaleLowerCase();
      });
      tempData = [...this.dataSet].filter((entry) => {
        const temp = entry.report_type.split(',');
        return (
          this.reportTypeFilterValue.indexOf(temp[0].toLocaleLowerCase()) > -1
        );
      });
    }
    if (this.filterData.deliveryMethod.length > 0) {
      this.deliveryMethodFilterValue = [...this.filterData.deliveryMethod];
      this.deliveryMethodFilterValue.map((entry: any, index: number) => {
        this.deliveryMethodFilterValue[index] = entry.toLocaleLowerCase();
      });
      tempData = tempData.filter((entry) => {
        const temp = entry.delivery_method.split(',');
        let status = 0;
        for (let i = 0; i < temp.length; i = i + 1) {
          const filterStatus = this.deliveryMethodFilterValue.indexOf(
            temp[i].toLocaleLowerCase()
            .trim(),
          );
          if (filterStatus > -1) {
            status = 1;
            break;
          }
        }
        if (status === 1) {
          return true;
        }
      });
    }
    if (this.filterData.status.length > 0) {
      this.statusFilterValue = [...this.filterData.status];
      this.statusFilterValue.map((entry: any, index: number) => {
        this.statusFilterValue[index] = entry.toLocaleLowerCase();
      });
      tempData = tempData.filter((entry) => {
        return (
          this.statusFilterValue.indexOf(entry.status.toLocaleLowerCase()) > -1
        );
      });
    }
    if (this.filterData.product.length > 0) {
      this.productFilterValue = [...this.filterData.product];
      this.productFilterValue.map((entry: any, index: number) => {
        this.productFilterValue[index] = entry.toLocaleLowerCase();
      });
      tempData = tempData.filter((entry) => {
        return (
          this.productFilterValue.indexOf(
            entry.product_name.toLocaleLowerCase(),
          ) > -1
        );
      });
    }
    this.dummyData = [...tempData];
    this.loadedData = [];
    this.onLoadMore(20);
    this.filteredData = [...this.dummyData];
    if (this.stringToSearch !== '' && this.stringToSearch.length > 3) {
      this.searchText();
    }
  }

  @Watch('tenantName', { immediate: true })
  refreshReportDataOnTenantChange() {
    if (this.watchTenantName) {
      this.getReportDataFromApi();
    }
  }

  @Watch('showTableLoading', { immediate: true })
  applyFilter() {
    !this.showTableLoading && this.onFilterApply();
  }

  @Watch('isLoading', { immediate: true })
  applyFilterAfterDownload() {
    !this.isLoading && this.onFilterApply();
  }

  /**
   * @desc API call for WNM reports
   */
  async getWnmReportData() {
    const apiParams: any = {};
    this.wnmFlag = false;
    this.setWcmOnDemandReportsCount(0);
    await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('wireless')
      ?.getApiData('/system/reports/tasks', apiParams)
      .then((response: any) => {
        response.map((entry: any) => {
          const tempData = {
            id: entry.id || '-',
            status:  String(entry.status)
            .charAt(0)
            .toUpperCase() + String(entry.status)
            .slice(1) || '-',
            product_name: 'Wireless',
            productName: 'Wireless',
            report_type: entry.generate_from === 'schedule' ? 'scheduled' : entry.generate_from,
            delivery_method: `${entry.hasOwnProperty('config') ?
                                entry.config.hasOwnProperty('schedule') ?
                                entry.config.schedule.hasOwnProperty('send_email') ?
                                entry.config.schedule.send_email ? 'Email' : 'Download'
                             : 'Download'
                             : 'Download'
                             : 'Download' }`,
            reportData: [],
            report_name: entry.name || '-',
            view : entry.view ? String(entry.view) : '',
            requested_at: entry.created_time ? this.dateFormat(entry.created_time) : '-',
            last_run_time: entry.created_time ? this.dateFormat(entry.created_time) : '-',
            generated_at: entry.created_time ? this.dateFormat(entry.created_time) : '-',
            filename : entry.filename,
            Data: [],
            url : entry.url,
            config: entry.config ? entry.config : {},
            option: entry.hasOwnProperty('config') ?
              entry.config.hasOwnProperty('option') ?
              entry.config.option : {} : {},
          };
          this.dummyData.push(tempData);
          this.dataSet.push(tempData);
        });
        this.setWcmOnDemandReportsCount(this.getWcmOnDemandReportsCount(this.dataSet));
      })
      .catch((error: any) => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.failWireRep')
          .toString(),
          'failed',
        );
        console.error('WNM Report Data API Error', error);
        this.setWcmOnDemandReportsCount(0);
      })
      .finally(() => {
        this.wnmFlag = true;
      });
  }
  /**
   * @desc methods to fetch the number of on demand records.
  */
  getWcmOnDemandReportsCount(reports: any[]) {
    const reportsData = _.cloneDeep(reports);
    const totalOnDemandReports = reportsData &&
      reportsData.length > 0 &&
      reportsData.filter((report: any) => {
        return report['report_type'] &&
          report['report_type'] === 'ondemand' &&
          (report['productName'] === 'Wireless' || report['product_name'] === 'Wireless');
      })?.length || 0;
    return totalOnDemandReports;
  }

  /**
   * @desc API call for NSM rule reports
   */
  async getNsmReportData() {
    let flag = 0;
    const apiParams: any = { archivedFilesLimit: 1 };
    this.nsmRuleFlag = false;
    await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('firewall')
      ?.getApiData('/reportconfig/taskwitharchive', apiParams)
      .then((response: any) => {
        if (response.status && !response.status.success) {
          throw new Error(response.status.info[0].message);
        }
        if (response.status && response.status.success) {
          flag = 1;
          throw new Error(response.status.info[0].message);
        }
        const nsmProgressTemp = response.filter((row : any) => row.status === 'Progress');
        if (nsmProgressTemp.length > 0) {
          this.nsmReportInprogress = nsmProgressTemp;
          clearTimeout(this.clearTimeoutVar);
          this.clearTimeoutVar = setTimeout(this.callBackfunction.bind(this), 30000);
        }// else if (updateProgress && this.nsmReportInprogress.length > 0) {
        //   console.log(this);
        //   debugger;
        //   console.log('before dataset: ', this.dataSet);
        //   console.log('before dummy', this.dummyData);
        //   this.nsmReportInprogress.forEach(
        //     (item : any) => {
        //       const entry = response.find((row : any) => row.taskName === item.taskName);
        //       if (entry) {
        //         let tempData: any = {};
        //         tempData = {
        //           id: entry._id.$oid || '-',
        //           product_name: 'Firewall',
        //           status: entry.status ? (entry.status[0].toLocaleUpperCase() + entry.status.slice(1)) : '-',
        //           report_type: this.reportTypeNsm(entry.deliveryConfig),
        //           reportType: 'Rules', // Need to be added to control the drop down button control
        //           delivery_method: `${
        //             entry.deliveryConfig.archiveConfig &&
        //               !entry.deliveryConfig.emailConfig
        //             ? 'Archive'
        //             : !entry.deliveryConfig.archiveConfig &&
        //               entry.deliveryConfig.emailConfig
        //             ? 'Email'
        //             : entry.deliveryConfig.archiveConfig &&
        //               entry.deliveryConfig.emailConfig
        //             ? 'Archive, Email'
        //             : ''
        //             }`,
        //           reportData: [entry, 'Firewall'],
        //           report_name: entry.taskName || '-',
        //           view : entry.view ? String(entry.view) : '-',
        //           requested_at:
        //           entry.lastRunTS === 0 ? '-' : this.dateFormat(entry.lastRunTS),
        //           last_run_time: entry.lastRunTS === 0 ? '-' : this.dateFormat(entry.lastRunTS),
        //           productName: 'firewall',
        //           intervalType: entry.intervalType || 0,
        //           scheduleId: entry.scheduleId,
        //           generated_at: entry.nextScheduleTS ? this.dateFormat(entry.nextScheduleTS) : '-',
        //         };
        //         let progressIndex = this.dummyData.findIndex((row : any) => row.report_name === entry.taskName);
        //         this.dummyData[progressIndex] =  tempData;
        //         progressIndex = this.dataSet.findIndex((row : any) => row.scheduleId === entry.scheduleId);
        //         this.dataSet[progressIndex] =  tempData;
        //         console.log('dataset: ', this.dataSet);
        //         console.log('dummy', this.dummyData);
        //       }
        //     },
        //     this,
        //   );
        //   return;
        // }
        response.map((entry: any) => {
          let tempData: any = {};
          tempData = {
            id: entry._id.$oid || '-',
            product_name: 'Firewall',
            status: entry.status ? (entry.status[0].toLocaleUpperCase() + entry.status.slice(1)) : '-',
            report_type: this.reportTypeNsm(entry.deliveryConfig),
            reportType: 'Rules', // Need to be added to control the drop down button control
            delivery_method: `${
              entry.deliveryConfig.archiveConfig &&
              !entry.deliveryConfig.emailConfig
                ? 'Archive'
                : !entry.deliveryConfig.archiveConfig &&
                  entry.deliveryConfig.emailConfig
                ? 'Email'
                : entry.deliveryConfig.archiveConfig &&
                  entry.deliveryConfig.emailConfig
                ? 'Archive, Email'
                : ''
            }`,
            reportData: [entry, 'Firewall'],
            report_name: entry.taskName || '-',
            view : entry.view ? String(entry.view) : '-',
            intervalType : entry.intervalType || 0,
            requested_at:
              entry.lastRunTS === 0 ? '-' : this.dateFormat(entry.lastRunTS),
            last_run_time: entry.lastRunTS === 0 ? '-' : this.dateFormat(entry.lastRunTS),
            productName: 'firewall',
            scheduleId: entry.scheduleId,
            generated_at: entry.nextScheduleTS ? this.dateFormat(entry.nextScheduleTS) : '-',
            archiveFiles: entry.archiveFiles ? entry.archiveFiles : [],
          };
          this.dummyData.push(tempData);
          this.dataSet.push(tempData);
        });
      })
      .catch((error: any) => {
        if (flag === 0) {
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.$t('spog.unifiedInsights.failFireRuleRepr')
            .toString(),
            'failed',
          );
        }
        console.error('NSM Report Data API Error', error);
      })
      .finally(() => {
        this.nsmRuleFlag = true;
      });
  }

  callBackfunction () {
    this.removeNSMReports();
    this.getNsmReportData();
  }

  /**
   * @desc API call for NSM archive reports
   */
  async getNsmArchiveReportData() {
    let flag = 0;
    const apiParams: any = {
      view: 2,
    };
    this.nsmArchiveFlag = false;
    await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('firewall')
      ?.getApiData('/reportconfig/archivedreportlist', apiParams)
      .then((response: any) => {
        if (response.status && !response.status.success) {
          throw new Error(response.status.info[0].message);
        }
        if (response.status && response.status.success) {
          flag = 1;
          throw new Error(response.status.info[0].message);
        }
        const scheduleNameMap = new Map();
        response.map((entry: any , index : any) => {
          let tempData: any = {};
          let replaceIndex = -1;
          let pushToArray = true;
          if (entry.scheduleName && scheduleNameMap.has(entry.scheduleName)) {
            if (scheduleNameMap.get(entry.scheduleName).generatedTime > entry.generatedTS) {
              pushToArray = false;
            } else {
              replaceIndex = scheduleNameMap.get(entry.scheduleName).index;
            }
          } else {
            scheduleNameMap.set(entry.scheduleName, { index, generatedTime : entry.generatedTS });
          }
          if (pushToArray) {
            tempData = {
              id: entry._id || '-',
              product_name: 'Firewall',
              status: 'Available',
              report_type: entry.trigger || '-',
              reportType: 'Archived',
              delivery_method: 'Download',
              reportData: [entry, 'Firewall'],
              report_name: entry.scheduleName || '-',
              view : entry.view ? String(entry.view) : '-',
              productName: 'firewall',
              _id: entry._id,
              scheduleId: entry.scheduleTaskId || '',
              requested_at: entry.startTS ? this.dateFormat(entry.startTS) : '-',
              last_run_time: entry.generatedTS ? this.dateFormat(entry.generatedTS) : '-',
              generated_at: entry.generatedTS ? this.dateFormat(entry.generatedTS) : '-',
            };
            if (replaceIndex === -1) {
              this.dummyData.push(tempData);
              this.dataSet.push(tempData);
            } else {
              this.dummyData.splice(replaceIndex, 1, tempData);
              this.dataSet.splice(replaceIndex, 1, tempData);
            }
          }
        });
      })
      .catch((error: any) => {
        if (flag === 0) {
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.$t('spog.unifiedInsights.failFireArcRepr')
            .toString(),
            'failed',
          );
        }
        console.error('NSM Report Data API Error', error);
      })
      .finally(() => {
        this.nsmArchiveFlag = true;
      });
  }

  addArchiveReportData(entry: any) {
    const tempData: any = {
      id: entry._id || '-',
      product_name: 'Firewall',
      status: 'Available',
      report_type: entry.trigger || '-',
      reportType: 'Archived',
      delivery_method: 'Download',
      reportData: [entry, 'Firewall'],
      report_name: entry.scheduleName || '-',
      view : entry.view ? String(entry.view) : '-',
      productName: 'firewall',
      _id: entry._id,
      scheduleId: entry.scheduleTaskId || '',
      requested_at: entry.startTS ? this.dateFormat(entry.startTS) : '-',
      last_run_time: entry.generatedTS ? this.dateFormat(entry.generatedTS) : '-',
      generated_at: entry.generatedTS ? this.dateFormat(entry.generatedTS) : '-',
    };
    this.dummyData.push(tempData);
    this.dataSet.push(tempData);
  }

  /**
   * @desc API call for capture client reports list.
   */
  async getCcReportData() {
    const apiParams: any = {};
    this.ccAvailableFlag = false;
    await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('capture client')
      ?.getApiData('/report/list', apiParams)
      .then((response: any) => {
        response.map((entry: any) => {
          let tempData: any = {};
          tempData = {
            id: entry._id || '-',
            product_name: 'Capture Client',
            status: entry.status || '-',
            report_type: 'OnDemand',
            reportType: 'OnDemand',
            reportData: [entry, 'Capture Client'],
            delivery_method: entry.action || '-',
            report_name: entry.name || '-',
            requested_at: entry.taskCreationTs ? this.dateFormat(entry.taskCreationTs) : '-',
            last_run_time: entry.generationTs ? this.dateFormat(entry.generationTs) : '-',
            generated_at: entry.generationTs ? this.dateFormat(entry.generationTs) : '-',
            downloadUrl: entry.downloadUrl,
            fileFormat: entry.fileFormat,
            taskId: entry.taskId,
            productName: 'Capture Client',
          };
          this.dummyData.push(tempData);
          this.dataSet.push(tempData);
        });
      })
      .catch((error: any) => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.failCCAvailRepr')
          .toString(),
          'failed',
        );
        console.error('CC Report Data API Error', error);
      })
      .finally(() => {
        this.ccAvailableFlag = true;
      });
  }

  /**
   * @desc Returns time in hh:mm:ss format.
   * @Params schedule describes possible value of schedule
   * @Params day describes possible value of day
   * @Params hour describes possible value of hour
   */
  requestedAt(schedule: string, day: number, hour: number) {
    return schedule === 'daily'
      ? day === 0
        ? `${Math.floor(this.getPointBasedTime('point-based') + hour) % 24 < 9 ? 0 : ''}${String(
            Math.floor(this.getPointBasedTime('point-based') + hour) % 24,
          )}:${String(((this.getPointBasedTime('point-based') + hour) * 60) % 60)}:00`
        : this.getUtcTime('minute-based')
      : schedule === 'weekly'
      ? this.weekDays[day]
      : day < 31 ? `${this.addPostfix(day)} day of the month` : 'last day of the month';
  }
  //
  getPointBasedTime(type:string):number {
    return Number(this.getUtcTime(type));
  }

  removeNSMReports() {
    this.dummyData = this.dummyData.filter(ele =>  ele.product_name !== 'Firewall');
    this.dataSet = [...this.dummyData];
    this.loadedData = this.loadedData.filter(ele => ele.product_name !== 'Firewall');
  }

  getUtcTime(type:string):string {
    const time = new Date().getTimezoneOffset();
    let hours;
    let minutes;
    if (time < 0) {
      hours = -_.ceil(time / 60);
      minutes = -(time % 60);
    } else {
      hours = 24 - _.ceil(time / 60);
      hours === 0 && (hours = 12);
      minutes = time % 60;
    }
    if (type === 'point-based') {
      minutes = minutes === 30 ? '5' : '';
      return `${hours}.${minutes}`;
    }
    hours = hours > 9 ? `${hours}` : `0${hours}`;
    minutes = minutes === 30 ? `${minutes}` : '00';
    return `${hours}:${minutes}:00`;
  }

  dateFormat(timeStamp: number) {
    return moment.unix(timeStamp)
    .format('MM/DD/YYYY | hh:mm:ss A');
  }

  addPostfix(day: number): string {
    if (day % 10 === 1) {
      return `${day}st`;
    }
    if (day % 10 === 2) {
      return `${day}nd`;
    }
    if (day % 10 === 3) {
      return `${day}rd`;
    }
    return `${day}th`;
  }

  /**
   * @desc API call for capture client scheduled reports list.
   */
  weekDays: { [key: number]: string } = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  };
  async getCcScheduledReportData() {
    const apiParams: any = {};
    this.ccScheduleFlag = false;
    await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('capture client')
      ?.getApiData('/report/scheduledReports', apiParams)
      .then((response: any) => {
        response.map((entry: any) => {
          let tempData: any = {};
          tempData = {
            id: entry._id || '-',
            product_name: 'Capture Client',
            status: 'Available',
            reportType: 'Scheduled',
            report_type: this.reportTypeCc(entry.day, entry.schedule),
            delivery_method: 'Download, Email',
            reportData: [entry, 'Capture Client'],
            report_name: entry.name || '-',
            requested_at: this.requestedAt(
              entry.schedule,
              entry.day,
              entry.hour,
            ) || '-',
            generated_at: this.requestedAt(
              entry.schedule,
              entry.day,
              entry.hour,
            ) || '-',
            last_run_time: this.requestedAt(
              entry.schedule,
              entry.day,
              entry.hour,
            ) || '-',
            taskId: entry.taskId || '-',
            fileFormat: entry.fileFormat || '-',
            scheduleId: entry.scheduleId || '',
            productName: 'Capture Client',
            ccScheduleReportData: entry,
          };
          this.dummyData.push(tempData);
          this.dataSet.push(tempData);
        });
      })
      .catch((error: any) => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.failCCSchRepr')
          .toString(),
          'failed',
        );
        console.error('CC Report Data API Error', error);
      })
      .finally(() => {
        this.ccScheduleFlag = true;
      });
  }

  /**
   * @desc Returns report type for CC scheduled reports.
   * @param day On which day report should be delivered.
   * @param schedule Describes report frequency
   */
  reportTypeCc(day: number, schedule: string) {
    return schedule === 'daily'
      ? 'Scheduled, Daily'
      : schedule === 'weekly'
      ? `Scheduled, Weekly every ${this.weekDays[(day >= 1 && day <= 7) ? day : 0]}`
      : (day >= 4 && day <= 20) || (day >= 24 && day <= 30)
      ? `Scheduled, Monthly every ${day}th day`
      : day === 1 || day === 21
      ? `Scheduled, Monthly every ${day}st day`
      : day === 2 || day === 22
      ? `Scheduled, Monthly every ${day}nd day`
      : day === 3 || day === 23
      ? `Scheduled, Monthly every ${day}rd day`
      : 'Scheduled, last day of the month';
  }

  /**
   * @desc Returns report type for NSM scheduled reports.
   * @param deliveryConfig Object contains info about delivery.
   */
  reportTypeNsm(deliveryConfig: any) {
    return deliveryConfig.dayOfMonth
      ? (deliveryConfig.dayOfMonth >= 4 && deliveryConfig.dayOfMonth <= 20) ||
        (deliveryConfig.dayOfMonth >= 24 && deliveryConfig.dayOfMonth <= 28)
        ? `Scheduled, Monthly every ${deliveryConfig.dayOfMonth}th day`
        : deliveryConfig.dayOfMonth === 1 || deliveryConfig.dayOfMonth === 21
        ? `Scheduled, Monthly every ${deliveryConfig.dayOfMonth}st day`
        : deliveryConfig.dayOfMonth === 2 || deliveryConfig.dayOfMonth === 22
        ? `Scheduled, Monthly every ${deliveryConfig.dayOfMonth}nd day`
        : deliveryConfig.dayOfMonth === 31 || deliveryConfig.dayOfMonth === 32
        ? 'Scheduled, last day of the month'
        : `Scheduled, Monthly every ${deliveryConfig.dayOfMonth}rd day`
      : deliveryConfig.dayOfWeek
      ? `Scheduled, Weekly every ${this.weeksForNSM(deliveryConfig.dayOfWeek)}`
      : 'Scheduled, Daily';
  }

  private weeksForNSM(dayOfWeek: any) {
    const days: { [key: number]: string } = {
      1: 'Sunday',
      2: 'Monday',
      3: 'Tuesday',
      4: 'Wednesday',
      5: 'Thursday',
      6: 'Friday',
      7: 'Saturday',
    };
    return days[dayOfWeek] || days[1];
  }

  get showTableLoading() {
    return !(
      this.ccScheduleFlag &&
      this.ccAvailableFlag &&
      this.nsmRuleFlag &&
      this.nsmArchiveFlag &&
      this.wnmFlag
    );
  }

  /**
   * @desc Based on users input in search field data will be filtered.
   */
  searchText() {
    if (this.stringToSearch === '') {
      this.dummyData = [...this.dataSet];
      this.onFilterApply();
      return;
    }
    const keyFilter: string[] = [
      'report_type',
      'report_name',
    ];
    if (
      this.filteredData.length === 0 &&
      this.filterData.status.length === 0 &&
      this.filterData.deliveryMethod.length === 0 &&
      this.filterData.reportType.length === 0 &&
      this.filterData.product.length === 0
    ) {
      this.filteredData = [...this.dataSet];
    }
    this.dummyData = this.filteredData.filter((row: any) => {
      let searchFlag: boolean = false;
      for (const dataKey in row) {
        if (row[dataKey]) {
          if (row.hasOwnProperty(dataKey) && keyFilter.includes(dataKey)) {
            searchFlag = row[dataKey]
              .toString()
              .toLocaleLowerCase()
              .indexOf(this.stringToSearch.toLocaleLowerCase()) > -1;
          }
          if (searchFlag) {
            return searchFlag;
          }
        }
      }
    });
    this.loadedData = [];
    this.onLoadMore(20);
  }

  mounted() {
    this.getReportDataFromApi();
    this.watchTenantName = true;
  }
  async getMetaData() {
    Promise.all([
      await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('firewall')
      ?.getApiData('/reportconfig/reportlist', { view:2, id:4 }),
      await unifiedInsightsApiService
      ?.getDataGroupApiWrapper('firewall')
      ?.getApiData('/reportconfig/reportlist', { view:2, id:1 }),
    ])
      .then((response : any) => {
        const flowReport = {
          flowData : response[0][0],
          managedData : response[1][0],
        };
        this.setNsmMetaData(flowReport);
        this.isLoading = false;
      });
  }
  async setNsmGroups() {
    await nsmApiService
      .getTenantGroups()
      .then((response) => {
        const groupsData = response.map((group: any) => {
          if (group.groupID && group.friendlyName) {
            let innerGroupDevices: any = [];
            if (group.deviceGroups) {
              innerGroupDevices = this.fetchInnerDevices(
                response,
                group.deviceGroups,
                [group.groupID],
              );
            }
            const groupDevices = group.devices ? group.devices : [];
            return {
              groupId: group.groupID,
              groupName: group.friendlyName,
              devices: [...groupDevices, ...innerGroupDevices] || [],
            };
          }
        });
        this.setTenantGroups(groupsData);
      })
      .catch((error: any) => {
        this.setTenantGroups([]);
        console.error('NSM fetch tenant groups API error', error);
      });
  }
  /**
   * @desc This function is used to fetch the devices in the inner groups
   * @param groupsData Reponse groups data
   * @param innerGroups inner Groups
   * @param visitedGroup visited groups
   */
  fetchInnerDevices(groupsData: any, innerGroups: any, visitedGroup: any) {
    if (!innerGroups) {
      return [];
    }
    let innerGroupDevices: any = [];
    innerGroups.map((innerGroupId: any) => {
      if (visitedGroup.includes(innerGroupId)) {
        return;
      }
      const innerGroup = groupsData.find(
        (responseGroup: any) => responseGroup.groupID === innerGroupId,
      );
      innerGroup &&
        innerGroup.devices &&
        (innerGroupDevices = [...innerGroupDevices, ...innerGroup.devices]);
      innerGroup &&
        innerGroup.deviceGroups &&
        (innerGroupDevices = [
          ...innerGroupDevices,
          ...this.fetchInnerDevices(groupsData, innerGroup.deviceGroups, [...visitedGroup, innerGroupId]),
        ]);
    });
    return innerGroupDevices;
  }
}
